import { SIGN_IN_PATH } from './routes';

const redirectToLogin = () => (window.location.href = SIGN_IN_PATH);

export default redirectToLogin;
